import async from "@shared-web/components/Async";
import { RouteObject } from "react-router-dom";
import useModuleVariables from "../hooks/useModuleVariables";

//Login and Reset
const SignIn = async(() => import("@pages/security/authentication/signIn"));
const ResetPassword = async(() => import("@pages/security/authentication/ResetPassword"));
const ForgetPassword = async(() => import("@pages/security/authentication/forgetPassword"));

//Error
const Page404 = async(() => import("@pages/security/authentication/Page404"));

//Repository
const ProjectRepositoryIndex = async(() => import("@pages/projectRepository/ProjectRepositoryIndex"));
const ProjectRepositoryPage = async(() => import("@pages/projectRepository/ProjectRepositoryPage"));

//Project Initiation
const ProjectInitiationIndex = async(() => import("@pages/projectInitiation/ProjectInitiationIndex"));
const ProjectInitiationPage = async(() => import("@pages/projectInitiation/ProjectInitiationPage"));

//Project Listing
const ProjectListingIndex = async(() => import("@pages/projectListing/ProjectListingIndex"));

//IPD
const ProjectIPDIndex = async(() => import("@pages/projectIPD/ProjectIPDIndex"));
const ProjectIPDPage = async(() => import("@pages/projectIPD/ProjectIPDPage"));

//Initiation Approval
const ProjectInitiationApprovalIndex = async(
  () => import("@pages/projectInitiationApproval/ProjectInitiationApprovalIndex"),
);
const ProjectInitiationApprovalPage = async(
  () => import("@pages/projectInitiationApproval/ProjectInitiationApprovalPage"),
);

//Commercials
const CommercialsIndexPage = async(() => import("@pages/projectCommercials/CommercialsIndexPage"));
const CommercialsForm = async(() => import("@pages/projectCommercials/CommercialsForm"));

//COGS Estimantion
const CogsEstimationIndex = async(() => import("@pages/cogsEstimation/CogsEstimationIndex"));
const CogsEstimationFormPage = async(() => import("@pages/cogsEstimation/CogsEstimationFormPage"));

//In-House-Selection
const InHouseSelectionIndexPage = async(() => import("@pages/inHouseSelection/InHouseSelectionIndex"));

//User Managaement
const UserManagementIndex = async(() => import("@pages/admin/userManagement/UserManagementIndex"));
const UserManagementForm = async(() => import("@pages/admin/userManagement/UserManagementForm"));
const GroupCurrencyForm = async(() => import("@pages/admin/groupCurrency/GroupCurrency"));
const DateFormatChange = async(() => import("@pages/admin/dateFormat/Dateformat"));
const ChangePasswordForm = async(() => import("@pages/admin/userManagement/ChangePasswordForm"));
const CurrencyFormatChange = async(() => import("@pages/admin/currencyFormat/CurrencyFormat"));
const GroupUomForm = async(() => import("@pages/admin/groupUom/GroupUom"));

//Master Managemnt
const MasterManagementIndex = async(() => import("@pages/admin/masterManagement/MasterManagementIndex"));

//Formulation development routes
const FormulationDevelopmenIndexPage = async(
  () => import("@pages/projectBudget/inHouseFormulationDevelopment/FormulationDevelopmenIndexPage"),
);
const FormulationDevelopmentForm = async(
  () => import("@pages/projectBudget/inHouseFormulationDevelopment/FormulationDevelopmentForm"),
);
const ExcipientsPMIndexPage = async(() => import("@pages/projectBudget/excipientsPM/ExcipientsPMIndex"));
const APIIndex = async(() => import("@pages/projectBudget/apiTabs/APIIndex"));
const APIPage = async(() => import("@pages/projectBudget/apiTabs/APIPage"));
const ExcipientsPMForm = async(() => import("@pages/projectBudget/excipientsPM/ExcipientsPMForm"));
const AnalyticalIndexPage = async(() => import("@pages/projectBudget/analytical/AnalyticalIndexPage"));
const AnalyticalForm = async(() => import("@pages/projectBudget/analytical/AnalyticalForm"));
const ToolingAndPlantCostIndex = async(
  () => import("@pages/projectBudget/toolingAndPlantCost/ToolingAndPlantCostIndex"),
);
const ToolingAndPlantCostForm = async(() => import("@pages/projectBudget/toolingAndPlantCost/ToolingAndPlantCostForm"));
const BERLDCostProjectDetailsIndexPage = async(
  () => import("@pages/projectBudget/be_RLD_Cost/BERLDCostProjectDetailsIndexPage"),
);
const BERLDCostProjectDetailsForm = async(() => import("@pages/projectBudget/be_RLD_Cost/BERLDCostProjectDetailsForm"));
const FilingCostIndex = async(() => import("@pages/projectBudget/filingCost/FilingCostIndex"));
const FilingCostForm = async(() => import("@pages/projectBudget/filingCost/FilingCostForm"));
const ManpowerCostIndexPage = async(() => import("@pages/projectBudget/manpowerCost/ManpowerCostIndexPage"));
const ManpowerCostForm = async(() => import("@pages/projectBudget/manpowerCost/ManpowerCostForm"));
const InLicensedProjectIndexPage = async(() => import("@pages/inLicensedProject/InLicensedProjectIndexPage"));
const InLicensedProjectForm = async(() => import("@pages/inLicensedProject/InLicensedProjectForm"));

// API Development Routes
const APIKSMDevelopmentIndexPage = async(
  () => import("@pages/apiDevelopment/apiksmDevelopment/APIKSMDevelopmentIndex"),
);
const APIKSMDevelopmentForm = async(() => import("@pages/apiDevelopment/apiksmDevelopment/APIKSMDevelopmentForm"));
const KSMRequirementIndexPage = async(() => import("@pages/apiDevelopment/ksmRequirement/KSMRequirementIndex"));
const KSMRequirementForm = async(() => import("@pages/apiDevelopment/ksmRequirement/KSMRequirementForm"));
const OtherMaterialsIndexPage = async(() => import("@pages/apiDevelopment/otherMaterials/OtherMaterialsIndex"));
const OtherMaterialsForm = async(() => import("@pages/apiDevelopment/otherMaterials/OtherMaterialsForm"));
const APIAnalyticalIndexPage = async(() => import("@pages/apiDevelopment/analytical/APIAnalyticalIndex"));
const APIManpowerCostIndexPage = async(() => import("@pages/apiDevelopment/manpowerCost/APIManpowerCostIndexPage"));
const APIManpowerCostForm = async(() => import("@pages/apiDevelopment/manpowerCost/APIManpowerCostForm"));
const APIDevToolingIndexPage = async(() => import("@pages/apiDevelopment/tooling/APIDevToolingIndex"));
const APIDevToolingForm = async(() => import("@pages/apiDevelopment/tooling/APIDevToolingForm"));
const APIPlantCostIndexPage = async(() => import("@pages/apiDevelopment/plantCost/PlantCostIndex"));
const APIPlantCostForm = async(() => import("@pages/apiDevelopment/plantCost/PlantCostForm"));
const APIFilingCostIndex = async(() => import("@pages/apiDevelopment/APIfilingCost/APIFilingCostIndex"));
const APIFilingCostForm = async(() => import("@pages/apiDevelopment/APIfilingCost/APIFilingCostForm"));

//API commercial
const APICommercialsIndexPage = async(() => import("@pages/apiCommercials/ApiCommercialIndex"));
const APICommercialsForm = async(() => import("@pages/apiCommercials/ApiCommercialsForm"));

//In-Licensed
const InLicensedProjectsList = async(() => import("@pages/reports/inLicensedProjectsTable/InLicensedProjectsList"));

// Reports
const ReportsDashboard = async(() => import("@pages/reports/ReportsDashboard"));
// const GanttChartIndex = async(() => import("@pages/reports/ganttCharts/GanttChartIndex"));
const GanttChartActual = async(() => import("@pages/reports/ganttCharts/GanttChartActual"));

//Revenue
const RevenueForm = async(() => import("@pages/revenue/revenueForm"));
const RevenueIndex = async(() => import("@pages/revenue/revenueIndex"));

//Final Schedule
const FinalScheduleIndexPage = async(() => import("@pages/finalSchedule/FinalScheduleIndexPage"));
const FinalScheduleForm = async(() => import("@pages/finalSchedule/FinalScheduleForm"));

// Final PL Evalution
const FinalPLEvaluationIndexPage = async(() => import("@pages/finalPL&Evaluation/FinalPLEvaluationIndexPage"));
const FinalPLEvaluationForm = async(() => import("@pages/finalPL&Evaluation/FinalPLEvaluationForm"));

// Final Approval
const FinalApprovalIndexPage = async(() => import("@pages/finalApproval/FinalApprovalIndexPage"));
const FinalApprovalForm = async(() => import("@pages/finalApproval/FinalApprovalForm"));
const DocumentsIndexPage = async(() => import("@pages/documents/DocumentsIndexPage"));
const DocumentsUploadPage = async(() => import("@pages/documents/DocumentsUploadForm"));

export const Routes = (isAuthenticated: Boolean): Array<RouteObject> => {
  const {
    Dashboard,
    Repository,
    ProjectListing,
    ProjectInitiation,
    IPD,
    InitiationApproval,
    CogsEstimation,
    Commercials,
    InHouseSelection,
    FormulationBudgetForm,
    APIDevelopmentForm,
    APICommercials,
    InLicensedProject,
    FinalSchedule,
    RevenueGCRollUp,
    FinalPLEvaluataion,
    Reports,
    Admin,
    UserManagement,
    MasterManagement,
    DateFormat,
    GroupCurrency,
    GroupUom,
    FinalApproval,
    FormulationDevelopment,
    API,
    ExcipientsPM,
    Analytical,
    BERLDCost,
    ToolingPlantCost,
    ManpowerCost,
    FilingCost,
    APIDevelopment,
    APIRequirement,
    OtherMaterials,
    AnalyticalAPI,
    ManpowerAPI,
    Tooling,
    PlantCost,
    APIFilingCost,
    Documents,
  } = useModuleVariables();

  return [
    {
      id: "page404-route",
      path: "*",
      Component: Page404,
    },
    {
      id: "dashboard-route",
      path: "/",
      Component: isAuthenticated ? (Dashboard ? ReportsDashboard : Page404) : SignIn,
    },
    {
      id: "projectRepositoryIndex-route",
      path: "/project-Repository-Index",
      Component: isAuthenticated ? (Repository ? ProjectRepositoryIndex : Page404) : SignIn,
    },
    {
      id: "projectRepositoryForm-route",
      path: "project-Repository-form",
      Component: isAuthenticated ? (Repository ? ProjectRepositoryPage : Page404) : SignIn,
    },
    {
      id: "projectInitiationIndex-route",
      path: "project-initiation",
      Component: isAuthenticated ? (ProjectInitiation ? ProjectInitiationIndex : Page404) : SignIn,
    },
    {
      id: "projectListingIndex-route",
      path: "/project-Listing-Index",
      Component: isAuthenticated ? (ProjectListing ? ProjectListingIndex : Page404) : SignIn,
    },
    {
      id: "projectInitiation-route",
      path: "project-initiation-form",
      Component: isAuthenticated ? (ProjectInitiation ? ProjectInitiationPage : Page404) : SignIn,
    },
    {
      id: "projectipdPage-route",
      path: "/project-ipdPage",
      Component: isAuthenticated ? (IPD ? ProjectIPDPage : Page404) : SignIn,
    },
    {
      id: "projectipdIndex-route",
      path: "/project-ipdIndex",
      Component: isAuthenticated ? (IPD ? ProjectIPDIndex : Page404) : SignIn,
    },
    {
      id: "commercialsIndex-route",
      path: "/project-commercialsIndex",
      Component: isAuthenticated ? (Commercials ? CommercialsIndexPage : Page404) : SignIn,
    },
    {
      id: "commercialsForm-route",
      path: "/project-commercials-form",
      Component: isAuthenticated ? (Commercials ? CommercialsForm : Page404) : SignIn,
    },
    {
      id: "projectInitiationApproval-route",
      path: "/project-iaIndex",
      Component: isAuthenticated ? (InitiationApproval ? ProjectInitiationApprovalIndex : Page404) : SignIn,
    },
    {
      id: "projectInitiationApprovalPage-route",
      path: "/project-iaPage",
      Component: isAuthenticated ? (InitiationApproval ? ProjectInitiationApprovalPage : Page404) : SignIn,
    },
    {
      id: "cogsEstimationIndex-route",
      path: "/cogs-estimation-index",
      Component: isAuthenticated ? (CogsEstimation ? CogsEstimationIndex : Page404) : SignIn,
    },
    {
      id: "cogsEstimationPage-route",
      path: "/cogs-estimationPage",
      Component: isAuthenticated ? (CogsEstimation ? CogsEstimationFormPage : Page404) : SignIn,
    },
    {
      id: "formulationDevelopmentIndex-route",
      path: "/pbf/formulation-development-index",
      Component: isAuthenticated
        ? FormulationBudgetForm && FormulationDevelopment
          ? FormulationDevelopmenIndexPage
          : Page404
        : SignIn,
    },
    {
      id: "formulationDevelopmentForm-route",
      path: "pbf/formulation-development-form",
      Component: isAuthenticated
        ? FormulationBudgetForm && FormulationDevelopment
          ? FormulationDevelopmentForm
          : Page404
        : SignIn,
    },
    {
      id: "apiIndex-route",
      path: "/pbf/api-index",
      Component: isAuthenticated ? (FormulationBudgetForm && API ? APIIndex : Page404) : SignIn,
    },
    {
      id: "apiPage-route",
      path: "pbf/api-page",
      Component: isAuthenticated ? (FormulationBudgetForm && API ? APIPage : Page404) : SignIn,
    },
    {
      id: "excipientPMIndex-route",
      path: "pbf/excipients-pm-index",
      Component: isAuthenticated ? (FormulationBudgetForm && ExcipientsPM ? ExcipientsPMIndexPage : Page404) : SignIn,
    },
    {
      id: "excipientPMForm-route",
      path: "pbf/excipients-pm-form",
      Component: isAuthenticated ? (FormulationBudgetForm && ExcipientsPM ? ExcipientsPMForm : Page404) : SignIn,
    },
    {
      id: "analyticalIndex-route",
      path: "pbf/analytical-index",
      Component: isAuthenticated ? (FormulationBudgetForm && Analytical ? AnalyticalIndexPage : Page404) : SignIn,
    },
    {
      id: "analyticalForm-route",
      path: "pbf/analytical-form",
      Component: isAuthenticated ? (FormulationBudgetForm && Analytical ? AnalyticalForm : Page404) : SignIn,
    },
    {
      id: "toolingPlantcostIndex-route",
      path: "pbf/tooling-plantcost-index",
      Component: isAuthenticated
        ? FormulationBudgetForm && ToolingPlantCost
          ? ToolingAndPlantCostIndex
          : Page404
        : SignIn,
    },
    {
      id: "toolingPlantCostForm-route",
      path: "pbf/tooling-plantcost-form",
      Component: isAuthenticated
        ? FormulationBudgetForm && ToolingPlantCost
          ? ToolingAndPlantCostForm
          : Page404
        : SignIn,
    },
    {
      id: "beRldCostProjectDetailsIndex-route",
      path: "pbf/be-rldCost-Project-details-index",
      Component: isAuthenticated
        ? FormulationBudgetForm && BERLDCost
          ? BERLDCostProjectDetailsIndexPage
          : Page404
        : SignIn,
    },
    {
      id: "beRldCostProjectDetailsForm-route",
      path: "pbf/be-rldCost-Project-details-form",
      Component: isAuthenticated
        ? FormulationBudgetForm && BERLDCost
          ? BERLDCostProjectDetailsForm
          : Page404
        : SignIn,
    },
    {
      id: "filingCostIndex-route",
      path: "pbf/filingcost-index",
      Component: isAuthenticated ? (FormulationBudgetForm && FilingCost ? FilingCostIndex : Page404) : SignIn,
    },
    {
      id: "filingCostForm-route",
      path: "pbf/filingcost-form",
      Component: isAuthenticated ? (FormulationBudgetForm && FilingCost ? FilingCostForm : Page404) : SignIn,
    },
    {
      id: "manpowerCostIndexPage-route",
      path: "pbf/manpower-cost-index",
      Component: isAuthenticated ? (FormulationBudgetForm && ManpowerCost ? ManpowerCostIndexPage : Page404) : SignIn,
    },
    {
      id: "manpowerCostForm-route",
      path: "pbf/manpower-cost-form",
      Component: isAuthenticated ? (FormulationBudgetForm && ManpowerCost ? ManpowerCostForm : Page404) : SignIn,
    },
    {
      id: "inLicensedProjectIndexPage-route",
      path: "inLicensed-project-index",
      Component: isAuthenticated ? (InLicensedProject ? InLicensedProjectIndexPage : Page404) : SignIn,
    },
    {
      id: "inLicensedProjectForm-route",
      path: "inLicensed-project-form",
      Component: isAuthenticated ? (InLicensedProject ? InLicensedProjectForm : Page404) : SignIn,
    },
    //User Management
    {
      id: "userManagementIndex-route",
      path: "/user-management-index",
      Component: isAuthenticated ? (Admin && UserManagement ? UserManagementIndex : Page404) : SignIn,
    },
    {
      id: "userManagementForm-route",
      path: "user-management-form",
      Component: isAuthenticated ? (Admin && UserManagement ? UserManagementForm : Page404) : SignIn,
    },
    {
      id: "groupCurrency-route",
      path: "group-currency",
      Component: isAuthenticated ? (Admin && GroupCurrency ? GroupCurrencyForm : Page404) : SignIn,
    },
    {
      id: "dateFormatChange-route",
      path: "date-format-change",
      Component: isAuthenticated ? (Admin && DateFormat ? DateFormatChange : Page404) : SignIn,
    },
    //Change Password
    {
      id: "changePasswordForm-route",
      path: "change-password-form",
      Component: isAuthenticated ? ChangePasswordForm : SignIn,
    },
    {
      id: "changeCurrencyForm-route",
      path: "change-currency-form",
      Component: isAuthenticated ? CurrencyFormatChange : SignIn,
    },
    //Master Management
    {
      id: "mastermanagementIndex-route",
      path: "master-management-Index",
      Component: isAuthenticated ? (Admin && MasterManagement ? MasterManagementIndex : Page404) : SignIn,
    },

    // API KSM Menus
    {
      id: "apiksmDevelopmentIndex-route",
      path: "/api/apiksm-development-index",
      Component: isAuthenticated
        ? APIDevelopmentForm && APIDevelopment
          ? APIKSMDevelopmentIndexPage
          : Page404
        : SignIn,
    },
    {
      id: "apiksmDevelopmentForm-route",
      path: "api/apiksm-development-form",
      Component: isAuthenticated ? (APIDevelopmentForm && APIDevelopment ? APIKSMDevelopmentForm : Page404) : SignIn,
    },
    {
      id: "ksmRequirementIndex-route",
      path: "/api/ksm-requirement-index",
      Component: isAuthenticated ? (APIDevelopmentForm && APIRequirement ? KSMRequirementIndexPage : Page404) : SignIn,
    },
    {
      id: "ksmRequirementForm-route",
      path: "api/ksm-requirement-form",
      Component: isAuthenticated ? (APIDevelopmentForm && APIRequirement ? KSMRequirementForm : Page404) : SignIn,
    },
    {
      id: "otherMaterialsIndex-route",
      path: "api/other-materials-index",
      Component: isAuthenticated ? (APIDevelopmentForm && OtherMaterials ? OtherMaterialsIndexPage : Page404) : SignIn,
    },
    {
      id: "otherMaterialsForm-route",
      path: "api/other-materials-form",
      Component: isAuthenticated ? (APIDevelopmentForm && OtherMaterials ? OtherMaterialsForm : Page404) : SignIn,
    },
    {
      id: "inHouseSectionIndex-route",
      path: "inHouse-selection-index",
      Component: isAuthenticated ? (InHouseSelection ? InHouseSelectionIndexPage : Page404) : SignIn,
    },
    {
      id: "analyticalIndex-route",
      path: "api/analytical-index",
      Component: isAuthenticated ? (APIDevelopmentForm && AnalyticalAPI ? APIAnalyticalIndexPage : Page404) : SignIn,
    },
    {
      id: "apimanpowercostIndex-route",
      path: "api/manpower-cost-index",
      Component: isAuthenticated ? (APIDevelopmentForm && ManpowerAPI ? APIManpowerCostIndexPage : Page404) : SignIn,
    },
    {
      id: "apimanpowercostForm-route",
      path: "api/manpower-cost-form",
      Component: isAuthenticated ? (APIDevelopmentForm && ManpowerAPI ? APIManpowerCostForm : Page404) : SignIn,
    },
    {
      id: "analyticalForm-route",
      path: "api/analytical-form",
      Component: isAuthenticated ? (APIDevelopmentForm && AnalyticalAPI ? AnalyticalForm : Page404) : SignIn,
    },
    {
      id: "apiDevToolingIndex-route",
      path: "api/api-dev-tooling-index",
      Component: isAuthenticated ? (APIDevelopmentForm && Tooling ? APIDevToolingIndexPage : Page404) : SignIn,
    },
    {
      id: "apiDevToolingForm-route",
      path: "api/api-dev-tooling-form",
      Component: isAuthenticated ? (APIDevelopmentForm && Tooling ? APIDevToolingForm : Page404) : SignIn,
    },
    {
      id: "plantCostIndex-route",
      path: "api/plant-cost-index",
      Component: isAuthenticated ? (APIDevelopmentForm && PlantCost ? APIPlantCostIndexPage : Page404) : SignIn,
    },
    {
      id: "plantCostForm-route",
      path: "api/plant-cost-form",
      Component: isAuthenticated ? (APIDevelopmentForm && PlantCost ? APIPlantCostForm : Page404) : SignIn,
    },
    {
      id: "filingCostIndex-route",
      path: "api/filingcost-index",
      Component: isAuthenticated ? (APIDevelopmentForm && APIFilingCost ? APIFilingCostIndex : Page404) : SignIn,
    },
    {
      id: "filingCostForm-route",
      path: "api/filingcost-form",
      Component: isAuthenticated ? (APIDevelopmentForm && APIFilingCost ? APIFilingCostForm : Page404) : SignIn,
    },
    {
      id: "reports-route",
      path: "/reports/dashboard",
      Component: isAuthenticated ? (Dashboard ? ReportsDashboard : Page404) : SignIn,
    },
    // {
    //   id: 'ganttChartIndex-route',
    //   path: '/reports/gantt-chart-index',
    //   Component: isAuthenticated ? Reports ?  GanttChartIndex : SignIn
    // },
    {
      id: "ganttChartActual-route",
      path: "/reports/actual-gantt-chart",
      Component: isAuthenticated ? (Reports ? GanttChartActual : Page404) : SignIn,
    },
    // {
    //   id: 'devExpressGanttChart-route',
    //   path: '/reports/dev-express-gantt-chart',
    //   Component: isAuthenticated ? Reports ?  DevExpressGanttChart : Page404: SignIn
    // },
    {
      id: "in-licensed-projects-table",
      path: "/reports/in-licensed-projects-table",
      Component: isAuthenticated ? (Reports ? InLicensedProjectsList : Page404) : SignIn,
    },
    {
      id: "finalScheduleIndex-route",
      path: "/final-schedule-index",
      Component: isAuthenticated ? (FinalSchedule ? FinalScheduleIndexPage : Page404) : SignIn,
    },
    {
      id: "finalScheduleForm-route",
      path: "/final-schedule-form",
      Component: isAuthenticated ? (FinalSchedule ? FinalScheduleForm : Page404) : SignIn,
    },
    {
      id: "finalPLEvaluationIndex-route",
      path: "/final-pl-evaluation-index",
      Component: isAuthenticated ? (FinalPLEvaluataion ? FinalPLEvaluationIndexPage : Page404) : SignIn,
    },
    {
      id: "finalPLEvaluationForm-route",
      path: "/final-pl-evaluation-form",
      Component: isAuthenticated ? (FinalPLEvaluataion ? FinalPLEvaluationForm : Page404) : SignIn,
    },
    {
      id: "documentsIndex-route",
      path: "/documents-index",
      Component: isAuthenticated ? (Documents ? DocumentsIndexPage : Page404) : SignIn,
    },
    {
      id: "documentsupload-route",
      path: "/upload-documents",
      Component: isAuthenticated ? (Documents ? DocumentsUploadPage : Page404) : SignIn,
    },
    {
      id: "finalApprovalIndex-route",
      path: "/final-approval-index",
      Component: isAuthenticated ? (FinalApproval ? FinalApprovalIndexPage : Page404) : SignIn,
    },
    {
      id: "finalApprovalForm-route",
      path: "/final-approval-form",
      Component: isAuthenticated ? (FinalApproval ? FinalApprovalForm : Page404) : SignIn,
    },
    //API Commercials Routes
    {
      id: "apiCommercialsIndex-route",
      path: "/api-commercial-index",
      Component: isAuthenticated ? (APICommercials ? APICommercialsIndexPage : Page404) : SignIn,
    },
    {
      id: "apiCommercialsForm-route",
      path: "/api-commercial-form",
      Component: isAuthenticated ? (APICommercials ? APICommercialsForm : Page404) : SignIn,
    },
    //Revenue
    {
      id: "revenueIndex-route",
      path: "/revenue-index",
      Component: isAuthenticated ? (RevenueGCRollUp ? RevenueIndex : Page404) : SignIn,
    },
    {
      id: "revenueForm-route",
      path: "/revenue-form",
      Component: isAuthenticated ? (RevenueGCRollUp ? RevenueForm : Page404) : SignIn,
    },
    {
      id: "groupUom-route",
      path: "group-uom",
      Component: isAuthenticated ? (Admin && GroupUom ? GroupUomForm : Page404) : SignIn,
    },

    //-------------Security Authorization-------------
  ];
};

export const authRoutes: Array<RouteObject> = [
  //-------------Security Authentication-------------
  {
    id: "signin-route",
    path: "/",
    Component: SignIn,
  },
  {
    id: "forgetpassword-route",
    path: "auth/forgetpassword",
    Component: ForgetPassword,
  },
  {
    id: "resetPassword-route",
    path: "reset/:token",
    Component: ResetPassword,
  },
];
